<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store.js';

const emit = defineEmits(['close']);

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const inboxes = useMapGetter('metaAgent/getInboxes');

const currentInboxId = computed(() => Number(route.params.inboxId));

// Stay on the same page, swap the phone number being configured.
const switchTo = inboxId => {
  emit('close');
  router.push({
    name: route.name,
    params: { accountId: route.params.accountId, inboxId },
  });
};
</script>

<template>
  <div
    class="z-50 w-64 py-2 overflow-y-auto border rounded-xl shadow-lg bg-n-alpha-3 backdrop-blur-2xl border-n-weak max-h-72"
  >
    <div class="px-3 py-1 text-xs font-medium text-n-slate-10">
      {{ t('META_AGENT.INBOX_SWITCHER.TITLE') }}
    </div>
    <button
      v-for="inbox in inboxes"
      :key="inbox.id"
      class="flex flex-col w-full gap-0.5 px-3 py-2 text-left hover:bg-n-slate-3"
      :class="{ 'bg-n-slate-3': inbox.id === currentInboxId }"
      @click="switchTo(inbox.id)"
    >
      <span class="text-sm truncate text-n-slate-12">{{ inbox.name }}</span>
      <span class="text-xs text-n-slate-11">{{ inbox.phone_number }}</span>
    </button>
    <div v-if="!inboxes.length" class="px-3 py-2 text-sm text-n-slate-11">
      {{ t('META_AGENT.INBOX_SWITCHER.EMPTY') }}
    </div>
  </div>
</template>
